module.exports = __webpack_public_path__ + "img/16_1.d2fdb74d.png";